import React, { FC } from 'react';

import HelpTooltip from '../help-tooltip';

import { requiredStyles, helpTooltipContainerStyles, helpStyles } from './styles';
import { FormFieldTooltipLabelProps } from './types';

const FormFieldTooltipLabel: FC<FormFieldTooltipLabelProps> = ({
  isRequired = false,
  label,
  content,
}) => (
  <div css={helpTooltipContainerStyles}>
    <span>{label}</span>
    {isRequired && <span css={requiredStyles}>*</span>}
    <span css={helpStyles}>
      <HelpTooltip>{content as React.ReactNode}</HelpTooltip>
    </span>
  </div>
);

export default FormFieldTooltipLabel;
